import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Card,
  Empty,
  Tag,
  Space,
  Popconfirm,
  Input,
  InputNumber,
  // Col,
  // Select,
  message,
  Col,
  Tooltip,
  Spin
} from 'antd';
import CustomTable from 'common/Content/CustomTable';
import Layout from '@/common/Layout';
import styles from '@/common/Layout/index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllDispenses,
  deleteDispense,
  getdetails,
  getFifo,
  getassaydetails,
  generateDispenseMaterialPdf
} from '../../redux/slice';
import { ValidateMaterial } from '@/features/dispensing/redux/slice';
import { DndContext } from '@dnd-kit/core';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  HolderOutlined,
  DeleteOutlined,
  EyeOutlined,
  ReadOutlined,
  SnippetsOutlined,
  PrinterOutlined,
  FormOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
import moment from 'moment';
import { getLoggedInUser, getRoles } from 'utilities/helpers';
import CustomModal from '@/common/CustomModal';
import SequenceModal from './SequenceModal';

const { Search } = Input;

// Defined at module scope (not inside the component) so its identity is stable
// across re-renders. Defining it inline caused React to remount the entire
// table body on every render, producing a flickering/see-through table behind
// the detail modals.
const Row = ({ children, ...props }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: props['data-row-key']
  });
  const style = {
    ...props.style,
    transform: CSS.Transform.toString(
      transform && {
        ...transform,
        scaleY: 1
      }
    )?.replace(/translate3d\(([^,]+),/, 'translate3d(0,'),
    transition,
    ...(isDragging
      ? {
          position: 'relative',
          // Capped below antd's modal layer (z-index 1000) so a drag-lifted
          // row can never paint over an open detail popup.
          zIndex: 9
        }
      : {})
  };
  return (
    <tr {...props} ref={setNodeRef} style={style} {...attributes}>
      {React.Children.map(children, (child) => {
        if (child?.key === 'id') {
          return React.cloneElement(child, {
            children: (
              <HolderOutlined
                ref={setActivatorNodeRef}
                style={{
                  touchAction: 'none',
                  cursor: 'move'
                }}
                {...listeners}
              />
            )
          });
        }
        return child;
      })}
    </tr>
  );
};

const ListofDispenseMaterials = () => {
  const { getAllMaterilLoading, pagination } = useSelector(
    (state) => state.material
  );
  const { user } = getLoggedInUser();
  const { Superadmindata } = getRoles('Warehouse');
  const { SuperadminQCdata } = getRoles('Quality Control');

  const [dataSource, setDataSource] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('');
  const debounceRef = useRef(null);
  const [showDisablePopup, setShowDisablePopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [expandData, setExpandData] = useState();
  const [fifoBatches, setFifoBatches] = useState([]);
  const [newBatches, setNewBatches] = useState();
  const [dispenseId, setDispenseId] = useState();
  const [viewAssay, setViewAssay] = useState(false);
  const [assayData, setAssayData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [allowedProductId, setAllowedProductId] = useState(null);
  const [sequenceModalVisible, setSequenceModalVisible] = useState(false);
  const [selectedBatchesForLC, setSelectedBatchesForLC] = useState([]);
  const [compaignMode, setCompaignMode] = useState(false);
  const [compaignBatchesForFifo, setcompaignBatchesForFifo] = useState([]);
  const [currentCompaignBatchesForFifoID, setCurrentCompaignBatchesForFifoID] =
    useState(null);
  const [assayLoading, setAssayLoading] = useState(false);
  const [assayFetchLoading, setAssayFetchLoading] = useState(false);
  const [assayProductBatchNumber, setAssayProductBatchNumber] = useState(null);
  const [assayProcessName, setAssayProcessName] = useState(null);
  const [assaySubProcessName, setAssaySubProcessName] = useState(null);
  const [printLoading, setPrintLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setDataSource([]);
    handleGetAllDispenses();
  }, [page, pageSize, search]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setPage(1);
      setSearch(value);
    }, 500);
  };
  const handleDeleteUser = (payload) => {
    dispatch(deleteDispense(payload)).then(() => {
      handleGetAllDispenses();
      setShowDisablePopup(false);
    });
  };

  const handleGetAllDispenses = () => {
    const payload =
      user?.role == 'qa_initiator'
        ? { page: page, search: search, per_page: pageSize, type: 'material' }
        : { page: page, search: search, per_page: pageSize };
    dispatch(getAllDispenses(payload)).then(function (response) {
      if (response?.payload?.success) {
        user?.role == 'qc_initiator'
          ? setDataSource(
              response?.payload?.data.filter(
                (data) => data?.status !== 'WH LC Pending'
              )
            )
          : setDataSource(response?.payload?.data);
      }
    });
  };

  const handlegetFefo = (id) => {
    setFifoBatches([]);
    setNewBatches([]);
    const payload = { id: id };
    setDispenseId(id);
    dispatch(getFifo(payload)).then((response) => {
      if (response?.payload?.success) {
        setFifoBatches(response?.payload?.data);
        setExpandData([]);
        setAssayData([]);
        setShowModal(true);
      }
    });
  };

  const handleAssayCal = () => {
    // const selected_batches = [];

    const myArrayFiltered = fifoBatches.filter((el) => {
      return selectedRowKeys.some((f) => {
        return f === el?.batches?.[0]?.number;
      });
    });

    const batches = [...myArrayFiltered].sort((a, b) =>
      a.type > b.type ? 1 : -1
    );

    const payload = {
      dispensing_request_id: dispenseId,
      bmr_material: batches
    };

    /* Assay Calculation API Call */
    setAssayLoading(true);
    dispatch(ValidateMaterial(payload)).then((response) => {
      setAssayLoading(false);
      if (response?.payload?.success) {
        message.success(response?.payload?.message);
        setShowModal(false);

        /* logic if compaign Mode is true then we update the next batch id by incremental way to make an get-fifo call using useEffect */
        if (compaignMode) {
          const indexOfCurrentCompaignBatchesForFifoID =
            compaignBatchesForFifo?.indexOf(currentCompaignBatchesForFifoID);

          if (
            indexOfCurrentCompaignBatchesForFifoID + 1 ===
            compaignBatchesForFifo?.length
          ) {
            //mode = false
            setCompaignMode(false);
            setCurrentCompaignBatchesForFifoID(null);
            setcompaignBatchesForFifo([]);
            const batches = selectedBatchesForLC?.map((btch) => btch.id);
            /*redirect to create checklist page if all compaign batches done with cal Assay*/
            history.push(`/create-checklist/${batches[0]}`, {});
          } else {
            // increment the compaign batch id for next get-fifo call
            setCurrentCompaignBatchesForFifoID(
              compaignBatchesForFifo[indexOfCurrentCompaignBatchesForFifoID + 1]
            );
          }
        }
      }
    });
  };
  const ShowdetailedView = (id, type) => {
    console.log(id, type);
    setShowModal(true);
    const payload = { id: id, type: type };
    dispatch(getdetails(payload)).then((response) => {
      if (response?.payload?.success) {
        console.log(response?.payload?.data);
        setFifoBatches([]);
        setAssayData([]);
        response?.payload?.data?.type == 'bmr'
          ? setExpandData(response?.payload?.data)
          : setExpandData(response?.payload?.data);
      }
    });
  };

  const ShowdetailedAssayView = (id, type) => {
    console.log(id, type);
    setDispenseId(id);
    setShowModal(true);
    setViewAssay(true);
    setAssayFetchLoading(true);
    const payload = { id: id, type: type };
    dispatch(getassaydetails(payload)).then((response) => {
      setAssayFetchLoading(false);
      if (response?.payload?.success) {
        console.log(response?.payload?.data, 'Assay data');
        setFifoBatches([]);
        setExpandData([]);
        setAssayProductBatchNumber(
          response?.payload?.product_batch_number || null
        );
        setAssayProcessName(response?.payload?.process_name || null);
        setAssaySubProcessName(response?.payload?.sub_process_name || null);
        setAssayData(response?.payload?.data);
      }
    });
  };

  const handlePrint = (id) => {
    setPrintLoading(true);
    dispatch(generateDispenseMaterialPdf({ id }))
      .then((response) => {
        if (response?.payload?.success) {
          const url = response?.payload?.data.split('/').pop();
          window.open(`${process.env.REACT_APP_STORAGE_URL}${url}`, '_blank');
          message.success(response?.payload?.message);
        } else {
          message.error(response?.payload?.message || 'Unable to generate PDF');
        }
      })
      .finally(() => setPrintLoading(false));
  };

  const visibility = useCallback(
    (record) => {
      return showDisablePopup[record.id];
    },
    [showDisablePopup]
  );

  const handleCampaign = (bacthes) => {
    localStorage.removeItem('batches');
    localStorage.setItem('batches', bacthes);

    const filteredBatches = dataSource.filter((item) =>
      bacthes.includes(item.id)
    );

    // old code logic
    // user?.role == 'qc_initiator' || user?.role == 'qa_super_user'
    //   ? history.push(`/qc-create-checklist/${bacthes[0]}`)
    //   : history.push(`/create-checklist/${bacthes[0]}`,{});

    if (user?.role == 'qc_initiator' || user?.role == 'qa_super_user') {
      history.push(`/qc-create-checklist/${bacthes[0]}`);
    } else if (
      filteredBatches?.length !== 0 &&
      filteredBatches?.every((b) => b.sub_type === 'auto')
    ) {
      /* 1) if selected batches sub type is auto then check for the following conditions */
      if (filteredBatches.every((b) => b.assay_status === true)) {
        message.error(
          'Assay calculation already done for All of the selected batches'
        );
        return;
      }

      /* 2) check all selected batches belongs to same product */
      if (
        !filteredBatches.every(
          (b, _, arr) => b.product_id === arr[0].product_id
        )
      ) {
        message.error('selected different product batches');
        return;
      }

      if (filteredBatches?.length !== 0) {
        const lcValues = filteredBatches?.map((b) => (b?.lc_uuid ?? '').trim());
        const uniques = new Set(lcValues);

        if (lcValues?.every((v) => v === '')) {
          // 1) all empty && none have assay status true
          // here flow will be show sequence modal then cal assay and then redirect to create checklist page
          if (filteredBatches.every((b) => b.assay_status !== true)) {
            setSelectedBatchesForLC(filteredBatches);
            setSequenceModalVisible(true);
            setCompaignMode(true);
          } else {
            message.error('unselect batches which have already done assay');
          }
        } else if (uniques?.size === 1 && lcValues[0] !== '') {
          // 2) all same and non-empty
          /*filter the batches which have assay status false and skip sequence modal. directly take to cal Assay and then re-direct to create checklist page */
          const filteredBatchesForAssay = filteredBatches.filter(
            (b) => b.assay_status === false
          );
          setCompaignMode(true);

          /*set compaignBatchesForFifo call as array of dispense request Ids*/

          const fifoOrder = filteredBatchesForAssay
            ?.sort((a, b) => (a.lc_batch_seq ?? 0) - (b.lc_batch_seq ?? 0))
            ?.map((item) => item.id); // returning dispense request ids array
          setSelectedBatchesForLC(filteredBatches);
          setcompaignBatchesForFifo(fifoOrder);
          setCurrentCompaignBatchesForFifoID(fifoOrder[0]);
        } else {
          // 3) otherwise, there are differences
          message.error('Please select batches within the same campaign');
        }
      }
    } else {
      /* 2) if selected batches sub type is full ie manual not auto then directly redirect to create checklist page */
      history.push(`/create-checklist/${bacthes[0]}`, {});
    }
  };

  const columns = [
    {
      title: 'Product Batch #',
      dataIndex: 'product_batch_number',
      ellipsis: true,
      width: '150px',
      fixed: 'left',
      render: (text, record) => {
        return user?.role == 'qc_initiator' || user?.role == 'qa_super_user' ? (
          <a href={`qc-create-checklist/${record?.line_clearance_input?.id}`}>
            {text || 'NA'}
          </a>
        ) : (user?.role == 'qa_initiator' && user?.level == 3) ||
          SuperadminQCdata?.[0]?.level == 3 ? (
          <a href={`dispensing/${record.id}`}>{text || 'NA'}</a>
        ) : (user?.role == 'qa_initiator' && user?.level == 2) ||
          SuperadminQCdata?.[0]?.level == 2 ? (
          text || 'NA'
        ) : (user?.level == 3 || Superadmindata?.[0]?.level == 3) &&
          record?.status == 'Dispensed' &&
          record?.sub_type == 'auto' ? (
          <a href={`dispensing-material/${record.id}`}>{text || 'NA'}</a>
        ) : (user?.level == 3 || Superadmindata?.[0]?.level == 3) &&
          record?.status == 'WH LC Pending' ? (
          // <a href={`create-checklist/${record.id}`}>{text || 'NA'}</a>
          text || 'NA'
        ) : (user?.level == 3 || Superadmindata?.[0]?.level == 3) &&
          (record?.status == 'Approved' || record?.status == 'Dispensed') &&
          record?.sub_type == 'auto' ? (
          <a href={`dispensing-material/${record.id}`}>{text || 'NA'}</a>
        ) : (user?.level == 2 || Superadmindata?.[0]?.level == 2) &&
          (record?.status == 'WH LC Pending' ||
            record?.status == 'QA LC Pending') ? (
          // <a href={`create-checklist/${record.id}`}>{text || 'NA'}</a>
          text || 'NA'
        ) : (user?.level == 2 || Superadmindata?.[0]?.level == 2) &&
          (record?.status == 'Approved' || record?.status == 'Dispensed') &&
          record?.sub_type == 'auto' ? (
          <a href={`dispensing-material/${record.id}`}>{text || 'NA'}</a>
        ) : ((user?.level == 3 || Superadmindata?.[0]?.level == 3) &&
            (record?.status == 'Approved' || record?.status == 'Dispensed') &&
            record?.sub_type == 'full') ||
          record?.sub_type == 'partial' ? (
          <a href={`manual_dispense/${record.id}?type=${record?.type}`}>
            {text || 'NA'}
          </a>
        ) : (user?.level == 2 || Superadmindata?.[0]?.level == 2) &&
          (record?.status == 'Approved' || record?.status == 'Dispensed') &&
          (record?.sub_type == 'full' || record?.sub_type == 'partial') ? (
          <a href={`manual_dispense/${record.id}?type=${record?.type}`}>
            {text || 'NA'}
          </a>
        ) : (user?.level == 2 ||
            user?.level == 3 ||
            Superadmindata?.[0]?.level == 2 ||
            Superadmindata?.[0]?.level == 3) &&
          (record?.status == 'Approved' || record?.status == 'Dispensed') &&
          record?.type == 'material' ? (
          <a href={`manual_dispense/${record.id}?type=${record?.type}`}>
            {text || 'NA'}
          </a>
        ) : (
          text || 'NA'
        );
      }
    },
    {
      title: 'BMR/Material #',
      dataIndex: 'bmr_number',
      ellipsis: true,
      width: '100px',
      // fixed: 'left',

      render: (text) => {
        return `${text || 'NA'}`;
      }
    },
    {
      title: 'Dispense Process',
      dataIndex: 'dispense_process_type_id',
      ellipsis: true,
      width: '160px',
      render: (_, record) => {
        const name = record?.prod_label_process_master?.process_label_name;
        const sub = record?.prod_label_sub_process?.sub_process_name;
        if (!name && !sub) return 'NA';
        return `${name || 'NA'}${sub ? ` › ${sub}` : ''}`;
      }
    },

    {
      title: 'Product Name',
      dataIndex: 'product_name',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return `${record?.product_detail?.name || 'NA'}`;
      }
    },
    {
      title: 'Created On',
      dataIndex: 'createdAt',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return `${moment(record?.createdAt).format('DD MMM YYYY') || 'NA'}`;
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return record?.status ? (
          <Tag
            color={
              record?.status === 'WH LC Pending'
                ? '#dc3545'
                : record?.status === 'QA LC Pending'
                ? '#ff9933'
                : record?.status === 'Approved'
                ? '#28a745'
                : '#007bff'
            }
          >
            {record?.status}
          </Tag>
        ) : (
          'NA'
        );
      }
    },
    {
      title: 'eBMR Status',
      dataIndex: 'ebmr_status',
      ellipsis: true,
      width: '120px',
      render: (text, record) => {
        return record?.ebmr_status ? (
          <Tag
            color={
              record?.ebmr_status === 'WH LC Pending'
                ? '#dc3545'
                : record?.ebmr_status === 'QA LC Pending' ||
                  record?.ebmr_status === 'QA Pending'
                ? '#ff9933'
                : record?.ebmr_status === 'Approved'
                ? '#28a745'
                : record?.ebmr_status === 'LC Verified'
                ? '#8fedf9ff'
                : record?.ebmr_status === 'Material Verified'
                ? '#22c55e'
                : record?.ebmr_status === 'Execution Inprocess'
                ? '#7ea7d6ff'
                : record?.ebmr_status === 'Execution Completed' ||
                  record?.ebmr_status === 'QA Reviewed'
                ? '#32f31cff'
                : '#007bff'
            }
          >
            {record?.ebmr_status}
          </Tag>
        ) : (
          'NA'
        );
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return (
          <Space>
            {record?.status !== 'Dispensed' &&
            record?.status !== 'Approved' &&
            user?.role == 'user' ? (
              <>
                <Popconfirm
                  title={`Are you sure do you want to ${
                    record.is_active ? 'Deactivate' : 'Activate'
                  } this Dispense?`}
                  visible={visibility(record)}
                  key={record.id}
                  onConfirm={(e) => {
                    e.stopPropagation();
                    handleDeleteUser({
                      id: record.id,
                      is_active: !record?.is_active
                    });
                  }}
                  onCancel={(e) => {
                    e.stopPropagation();
                    setShowDisablePopup({ [record.id]: false });
                  }}
                  okText={record.is_active ? 'Deactivate' : 'Activate'}
                  cancelText="No"
                  okButtonProps={{
                    loading: getAllMaterilLoading,
                    type: record.is_active ? 'danger' : 'primary'
                  }}
                >
                  {/* <DeleteOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDisablePopup({ [record.id]: true });
                }}
                style={{ color: '#e80e94' }}
              /> */}
                  <Tooltip title={record.is_active ? 'Deactivate' : 'Activate'}>
                    <DeleteOutlined size="small" checked={record.is_active} />
                  </Tooltip>
                </Popconfirm>
                {record.type == 'bmr' &&
                record?.sub_type === 'auto' &&
                record?.assay_status === false ? (
                  <Tooltip title="View">
                    <EyeOutlined
                      size="small"
                      onClick={() => handlegetFefo(record.id, record.type)}
                    />
                  </Tooltip>
                ) : record.type == 'bmr' &&
                  record?.sub_type !== 'auto' &&
                  record?.assay_status === false ? (
                  <Tooltip title="View">
                    <EyeOutlined
                      size="small"
                      onClick={() => ShowdetailedView(record.id, record.type)}
                    />
                  </Tooltip>
                ) : record.type == 'material' ? (
                  <Tooltip title="View">
                    <EyeOutlined
                      size="small"
                      onClick={() => ShowdetailedView(record.id, record.type)}
                    />
                  </Tooltip>
                ) : record.type == 'bmr' && record?.assay_status == true ? (
                  <Tooltip title="View Assay">
                    <ReadOutlined
                      size="small"
                      onClick={() =>
                        ShowdetailedAssayView(record.id, record.type)
                      }
                    />
                  </Tooltip>
                ) : (
                  ''
                )}
              </>
            ) : record.type == 'bmr' &&
              record.sub_type === 'auto' &&
              record?.assay_status === false ? (
              <Tooltip title="View">
                <EyeOutlined
                  size="small"
                  onClick={() => handlegetFefo(record.id, record.type)}
                />
              </Tooltip>
            ) : record.type == 'bmr' &&
              record.sub_type !== 'auto' &&
              record?.assay_status === false ? (
              <Tooltip title="View">
                <EyeOutlined
                  size="small"
                  onClick={() => ShowdetailedView(record.id, record.type)}
                />
              </Tooltip>
            ) : record.type == 'material' ? (
              <Tooltip title="View">
                <EyeOutlined
                  size="small"
                  onClick={() => ShowdetailedView(record.id, record.type)}
                />
              </Tooltip>
            ) : record.type == 'bmr' && record?.assay_status == true ? (
              <Tooltip title="View Assay">
                <ReadOutlined
                  size="small"
                  onClick={() => ShowdetailedAssayView(record.id, record.type)}
                />
              </Tooltip>
            ) : (
              ''
            )}
            {record?.status == 'Approved' && user?.role == 'qc_initiator' ? (
              <Tooltip title="Line Clearance Checklist">
                {/* Green tint = approved/done, pairs with the amber Resume icon. */}
                <SnippetsOutlined
                  style={{ color: '#28a745' }}
                  onClick={() => {
                    localStorage.removeItem('batches');
                    history.push(
                      `/qc-create-checklist/${record?.line_clearance_input?.id}`
                    );
                  }}
                />
              </Tooltip>
            ) : record?.status == 'Approved' && user?.role == 'user' ? (
              <Tooltip title="Line Clearance Checklist">
                {/* Green tint = approved/done, pairs with the amber Resume icon. */}
                <SnippetsOutlined
                  style={{ color: '#28a745' }}
                  onClick={() => {
                    localStorage.removeItem('batches');
                    history.push(
                      `/qc-create-checklist/${record?.line_clearance_input?.id}`
                    );
                  }}
                />
              </Tooltip>
            ) : (
              ''
            )}
            {/* Resume an in-progress WH line clearance that was left unsubmitted
                (logout / tab-close / navigation). Shown only once the checklist
                step is actually reachable — assay done, or manual (non-auto).
                Clearing the cache forces the checklist to rebuild the campaign
                from the URL id via the backend (lc_uuid). */}
            {record?.status == 'WH LC Pending' &&
            user?.role == 'user' &&
            (record?.assay_status === true || record?.sub_type !== 'auto') ? (
              <Tooltip title="Resume Line Clearance">
                {/* Amber "form to complete" — distinct from the green (done)
                    Line Clearance Checklist icon: amber = todo, green = done. */}
                <FormOutlined
                  style={{ color: '#fa8c16' }}
                  onClick={() => {
                    localStorage.removeItem('batches');
                    history.push(`/create-checklist/${record.id}`);
                  }}
                />
              </Tooltip>
            ) : (
              ''
            )}
          </Space>
        );
      }
    }
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelectionofAssay = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.status === 'QA Pending', // Disable checkbox if status is approved
      name: record.name
    })
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      console.log('Selection changed:', newSelectedRowKeys, selectedRows);

      // If deselecting all rows, reset everything
      if (newSelectedRowKeys.length === 0) {
        setSelectedRowKeys([]);
        setAllowedProductId(null);
        return;
      }

      // Get the current row's product_id from the first selected row
      const firstSelectedRow = selectedRows[0];
      if (!firstSelectedRow) {
        setSelectedRowKeys(newSelectedRowKeys);
        return;
      }

      // Set or get the allowed product_id
      const currentProductId = allowedProductId || firstSelectedRow.product_id;

      // If first selection, set the allowed product_id
      if (allowedProductId === null) {
        setAllowedProductId(currentProductId);
      }

      // Filter selected keys to only include rows with matching product_id
      const filteredKeys = [];
      selectedRows.forEach((row) => {
        if (row.product_id === currentProductId) {
          // Handle different key types based on user role
          const key =
            user?.role == 'qc_initiator' || user?.role == 'qa_super_user'
              ? row.line_clearance_input?.id
              : row.id;
          if (key) {
            filteredKeys.push(key);
          }
        }
      });

      console.log('Filtered keys:', filteredKeys);
      setSelectedRowKeys(filteredKeys);
    },

    getCheckboxProps: (record) => {
      // Only enable checkboxes for specific status based on role (reference from batches-list?type=lc_sampling)
      if (user?.role === 'qc_initiator') {
        // For qc_initiator, enable checkboxes for QA LC Pending status
        if (record.status !== 'QA LC Pending') {
          return {
            disabled: true,
            name: record.name
          };
        }
      } else {
        // For other roles, enable checkboxes for WH LC Pending status
        if (record.status !== 'WH LC Pending') {
          return {
            disabled: true,
            name: record.name
          };
        }
      }

      // If there's an allowed product_id and this row has a different product_id
      if (allowedProductId !== null && record.product_id !== allowedProductId) {
        return {
          disabled: true,
          name: record.name
        };
      }

      return {
        disabled: false,
        name: record.name
      };
    }
  };
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (newSelectedRowKeys, selectedRows) => {
  //     // If deselecting all rows, reset the allowed product_id
  //     console.log(newSelectedRowKeys.length, 'newSelectedRowKeys.length');
  //     if (newSelectedRowKeys.length === 0) {
  //       setSelectedRowKeys([]);
  //       setAllowedProductId(null);
  //       onSelectChange([], []);
  //       return;
  //     }

  //     // If this is the first selection, set the allowed product_id
  //     if (allowedProductId === null && selectedRows.length > 0) {
  //       setAllowedProductId(selectedRows[0].product_id);
  //     }

  //     // Filter to only include rows with the matching product_id
  //     const currentProductId = allowedProductId || selectedRows[0].product_id;
  //     const filteredKeys = newSelectedRowKeys.filter((key) => {
  //       const row = selectedRows.find((r) => (r.key || r.id) === key);
  //       return row && row.product_id === currentProductId;
  //     });

  //     setSelectedRowKeys(filteredKeys);

  //     // Get all selected rows across all pages (you'll need to maintain this)
  //     const allSelectedRows = dataSource.filter((row) =>
  //       filteredKeys.includes(row.key || row.id)
  //     );
  //     console.log(filteredKeys, allSelectedRows, 'ssss');
  //     onSelectChange(filteredKeys, allSelectedRows);
  //   },
  //   getCheckboxProps: (record) => {
  //     // Disable if status is 'QA Pending'
  //     if (record.status === 'QA Pending') {
  //       return {
  //         disabled: true,
  //         name: record.name
  //       };
  //     }

  //     // If there's an allowed product_id set, disable rows with different product_id
  //     if (allowedProductId !== null && record.product_id !== allowedProductId) {
  //       return {
  //         disabled: true,
  //         name: record.name
  //       };
  //     }

  //     return {
  //       disabled: false,
  //       name: record.name
  //     };
  //   }
  // };
  console.log(allowedProductId, selectedRowKeys, 'allowedProductId');

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no material requests to display
        </div>
      </span>
    )
  };

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSource((previous) => {
        const activeIndex = previous.findIndex((i) => i.id === active.id);
        const overIndex = previous.findIndex((i) => i.id === over?.id);
        return arrayMove(previous, activeIndex, overIndex);
      });
    }
  };
  useEffect(() => {
    if (newBatches?.length) {
      console.log('h');
    } else {
      const data = fifoBatches.map((item) => {
        const data = item.batches.map((item2) => {
          return {
            material_id: item?.material_id,
            batch_id: item2?.batch_details_id,
            name: item?.name,
            code: item?.code,
            standard_quantity: item?.standard_quantity,
            number: item2?.number,
            avl_qty: item2?.remaining_batch_qty,
            bin_number: item2?.bin_number,
            batch_details: item?.batch_details,
            batch_qty:
              item?.is_product == 'BPR'
                ? item?.dispensed_quantity
                : item?.batch_qty
          };
        });
        return data;
      });
      const dataMerge = [].concat.apply([], data);
      console.log(dataMerge);
      dataMerge?.length ? setNewBatches(dataMerge) : '';
    }
  }, [fifoBatches]);

  const columns1 = [
    {
      title: 'Material Code',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return record?.material?.code;
      }
    },
    {
      title: 'Material',
      dataIndex: 'upgradeNum',
      key: 'upgradeNum',
      render: (text, record) => {
        return record?.material?.name;
      }
    },
    {
      title: 'Required Quantity',
      dataIndex: 'upgradeNum',
      key: 'upgradeNum',
      render: (text, record) => {
        return `${record?.required_weight} ${record?.material?.uom}`;
      }
    }
  ];

  const columns2 = [
    {
      title: 'Material Code',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return record?.code;
      }
    },
    {
      title: 'Material',
      dataIndex: 'upgradeNum',
      key: 'upgradeNum',
      render: (text, record) => {
        return record?.name;
      }
    },
    {
      title: 'Required Quantity',
      dataIndex: 'standard_quantity',
      key: 'standard_quantity',
      render: (text, record) => {
        return record?.batch_qty;
      }
    },
    {
      title: 'BIN Location',
      dataIndex: 'bin_location',
      key: 'bin_location',
      render: (text, record) => {
        return record?.bin_number;
      }
    },
    {
      title: 'Inhouse Batch #',
      dataIndex: 'bin_location',
      key: 'bin_location',
      render: (text, record) => {
        return record?.number;
      }
    },
    {
      title: 'Available Quantity',
      dataIndex: 'upgradeNum',
      key: 'upgradeNum',
      render: (text, record) => (
        <InputNumber
          value={record?.avl_qty}
          min={1}
          max={100000}
          style={{
            width: '100%'
          }}
          placeholder="Enter Net Weight"
          disabled={true}
        />
      )
    }
  ];

  useEffect(() => {
    if (currentCompaignBatchesForFifoID) {
      // console.log(currentCompaignBatchesForFifoID, 'disReqId>>>>>>>');
      handlegetFefo(currentCompaignBatchesForFifoID); // in call showModal true
      setViewAssay(false);
    }
  }, [currentCompaignBatchesForFifoID]);

  // reset to page 1 when page size changes
  useEffect(() => {
    setPage(1);
  }, [pageSize]);
  return (
    <Layout sider={false}>
      <Card
        className={`${styles.cardStyles_approver}`}
        title={
          <span style={{ fontWeight: 'bold', color: '#c91761' }}>
            {user?.role == 'qc_initiator'
              ? 'Approval for LC Dispense Material'
              : 'Dispense Material'}
          </span>
        }
        extra={
          <Space>
            {user?.role == 'qa_initiator' ? (
              <CustomButton
                type="primary"
                ghost
                onClick={() => history.push('/dispensing')}
              >
                Create
              </CustomButton>
            ) : (
              ''
            )}
            <Search
              value={searchText}
              onChange={(e) => handleChange(e)}
              className={`w-100 ${styles.searchbar}`}
              justify="start"
              align="start"
              placeholder="Search by Product Batch / indent number"
            />
          </Space>
        }
      >
        <DndContext onDragEnd={onDragEnd}>
          <SortableContext
            items={dataSource.map((i) => i.id)}
            strategy={verticalListSortingStrategy}
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                locale={locale}
                loading={getAllMaterilLoading}
                columns={columns}
                dataSource={dataSource}
                rowSelection={rowSelection}
                rowKey={(record, index) =>
                  // Always return a unique, defined key. For QA/approver roles
                  // the natural key is the line-clearance entry id, but rows
                  // without a line clearance (e.g. "NA" rows) have none — that
                  // produced blank/duplicate keys, which let the drag layer
                  // mis-flag rows and bleed them over the detail popup. Fall
                  // back to a per-row key so every row is always distinct.
                  (user?.role == 'qc_initiator' || user?.role == 'qa_super_user'
                    ? record?.line_clearance_input?.id
                    : record?.id) ?? `row-${index}`
                }
                showPaginationMeta
                pagination={{
                  size: 'small',
                  total: pagination?.total_records || 0,
                  current: page,
                  pageSize: pageSize,
                  onChange: (newPage, newSize) => {
                    if (newSize !== pageSize) {
                      setPageSize(newSize);
                      setPage(1);
                    } else {
                      setPage(newPage);
                    }
                  }
                }}
                components={{
                  body: {
                    row: Row
                  }
                }}
                // rowKey="id"
                // className={styles.scrolling}
                scroll={{ x: 'auto' }}
                // expandable={{
                //   expandedRowRender,
                //   defaultExpandedRowKeys: ['0']
                // }}
              />
            </div>
          </SortableContext>
        </DndContext>
        <FormItem className="text-center">
          <CustomButton
            htmlType="button"
            type="primary"
            onClick={() => handleCampaign(selectedRowKeys)}
            disabled={selectedRowKeys?.length ? false : true}
          >
            Initiate Line Clearance
          </CustomButton>
        </FormItem>

        <SequenceModal
          visible={sequenceModalVisible}
          batches={selectedBatchesForLC}
          onCancel={() => {
            setSequenceModalVisible(false);
            setCompaignMode(false);
          }}
          onSuccessFulSequenceUpdation={(compaignBatchesresponse) => {
            setSequenceModalVisible(false);

            /*set compaignBatchesForFifo call as array of dispense request Ids*/
            const fifoOrder = compaignBatchesresponse?.created_batches
              ?.sort((a, b) => a.compaign_sequence - b.compaign_sequence)
              ?.map((item) => item.dispensing_request_id);
            setcompaignBatchesForFifo(fifoOrder);
            setCurrentCompaignBatchesForFifoID(fifoOrder[0]);
          }}
        />
      </Card>
      {showModal ? (
        <CustomModal
          title={
            viewAssay ? (
              <div
                style={{
                  color: '#c91761',
                  fontWeight: 'bold',
                  fontSize: 18,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                <div>
                  <div>
                    Dispense Material Details -{' '}
                    {assayProductBatchNumber ? assayProductBatchNumber : ''}
                  </div>
                  {assayProcessName || assaySubProcessName ? (
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 'normal',
                        color: '#666',
                        marginTop: 4
                      }}
                    >
                      Dispense Process: {assayProcessName || 'NA'}
                      {assaySubProcessName ? ` › ${assaySubProcessName}` : ''}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div>
                  {assayData?.length && assayData[0]?.lc_uuid ? (
                    <div>
                      <b style={{ color: '#c91761' }}>
                        Campaign batch sequence : {assayData[0]?.lc_batch_seq}
                      </b>
                    </div>
                  ) : (
                    ''
                  )}
                  {/* {assayProductBatchNumber ? (
                    <div>
                      <b style={{ color: '#c91761' }}>
                        Product Batch Number : 
                      </b>
                    </div>
                  ) : (
                    ''
                  )} */}
                </div>
              </div>
            ) : (
              'Dispense Material Details'
            )
          }
          visible={showModal}
          width={expandData?.type == 'material' ? '70%' : '70%'}
          footer={null}
          className={styles.customModal}
          closable={false}
        >
          {expandData?.type == 'material' ? (
            <CustomTable
              columns={columns1}
              dataSource={expandData?.dispensing_materials}
              pagination={false}
              loading={getAllMaterilLoading}
            />
          ) : expandData?.type == 'bmr' && expandData?.sub_type !== 'auto' ? (
            <div
              dangerouslySetInnerHTML={{
                __html: expandData?.bmr_partial_details
              }}
              // className={styles.tdbody}
            />
          ) : !viewAssay ? (
            <CustomTable
              rowSelection={rowSelectionofAssay}
              rowKey={(record) => record.number}
              columns={columns2}
              dataSource={newBatches}
              pagination={false}
              loading={getAllMaterilLoading}
            />
          ) : (
            ''
          )}
          <br />
          {!viewAssay ? (
            <FormItem className="text-center">
              <Space size={12}>
                <CustomButton
                  htmlType="button"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </CustomButton>
                {fifoBatches.length ? (
                  <CustomButton
                    htmlType="button"
                    type="primary"
                    onClick={() => handleAssayCal(false)}
                    loading={assayLoading}
                    disabled={assayLoading}
                  >
                    Calculate Assay
                  </CustomButton>
                ) : (
                  ''
                )}
              </Space>
            </FormItem>
          ) : (
            ''
          )}
          {viewAssay ? (
            <Spin spinning={assayFetchLoading}>
              <div style={{ marginTop: '-34px' }}>
                {assayData?.map((item, index) => {
                  const ids = item?.dispenseBatches.map(
                    ({ batch_number }) => batch_number
                  );
                  const filtered = item?.dispenseBatches.filter(
                    ({ batch_number }, idx) =>
                      !ids.includes(batch_number, idx + 1)
                  );

                  return (
                    <Col key={index} span={24} style={{ marginBottom: 8 }}>
                      <Card
                        title={
                          <b style={{ fontSize: '14px' }}>
                            {item?.material_name}
                          </b>
                        }
                        style={{ width: '100%' }}
                        extra={
                          <b
                            style={{
                              display: 'flex',
                              gap: '5px',
                              color: '#e80e94'
                            }}
                          >
                            {item?.is_extra == true ? (
                              <b
                                style={{
                                  color: 'white',
                                  backgroundColor: 'lightgreen',
                                  borderRadius: '5px',
                                  padding: '2px 5px'
                                }}
                              >
                                Extra-granular
                              </b>
                            ) : (
                              ''
                            )}
                            {item?.material_code}
                          </b>
                        }
                        className={styles.cardpadding}
                      >
                        <div style={{ marginBottom: 8 }}>
                          <b>Standard Qty :</b> {item?.required_qty}
                        </div>
                        <Space
                          size={4}
                          direction="vertical"
                          style={{ width: '100%' }}
                        >
                          {filtered?.map((batch, bIdx) => {
                            const hasAssay = filtered.some((b) => b?.assay);
                            return (
                              <div
                                key={bIdx}
                                style={{
                                  background: '#fafafa',
                                  padding: '6px 10px',
                                  borderRadius: 4,
                                  border: '1px solid #f0f0f0'
                                }}
                              >
                                <Space size={24} wrap>
                                  <span>
                                    <b>Inhouse Batch #:</b>{' '}
                                    {batch?.batch_number || 'NA'}
                                  </span>
                                  <span>
                                    <b>BIN #:</b> {batch?.bin_location || 'NA'}
                                  </span>
                                  <span>
                                    <b>Available Qty:</b>{' '}
                                    {batch?.remaining_batch_qty}
                                  </span>
                                  {hasAssay && (
                                    <>
                                      <span style={{ color: '#1890ff' }}>
                                        <b>Assay:</b> {batch?.assay || 'NA'}
                                      </span>
                                      <span style={{ color: '#1890ff' }}>
                                        <b>LOD / Water Content:</b>{' '}
                                        {batch?.lod_water_content || 'NA'}
                                      </span>
                                      <span style={{ color: '#1890ff' }}>
                                        <b>Solvent (%):</b>{' '}
                                        {batch?.solvent_percent || 'NA'}
                                      </span>
                                    </>
                                  )}
                                </Space>
                              </div>
                            );
                          })}

                          <div
                            style={{
                              marginTop: 8,
                              borderTop: '1px solid #f0f0f0',
                              paddingTop: 8
                            }}
                          >
                            <b>Lots / Parts Dispensed:</b>
                            <Space
                              size={4}
                              direction="vertical"
                              style={{ width: '100%', marginTop: 4 }}
                            >
                              {item?.dispenseLots?.map((lot, lIdx) => {
                                const lotLabel =
                                  lot?.lot_no
                                    .replace(/_/g, ' ')
                                    .charAt(0)
                                    .toUpperCase() +
                                  lot?.lot_no.replace(/_/g, ' ').slice(1);

                                return (
                                  <div
                                    key={lIdx}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 8
                                    }}
                                  >
                                    <span>
                                      {lotLabel}: <b>{lot?.dispensed_qty}</b>
                                    </span>
                                  </div>
                                );
                              })}
                            </Space>
                            {/* <div style={{ marginTop: 6 }}>
                            <b>Total Dispensed: </b>
                            {item?.dispenseLots
                              ?.reduce(
                                (sum, l) =>
                                  sum + parseFloat(l?.dispensed_qty || 0),
                                0
                              )
                              .toFixed(3)}
                          </div> */}
                          </div>
                        </Space>
                      </Card>
                    </Col>
                  );
                })}
                <FormItem className="text-center" style={{ marginTop: 12 }}>
                  <Space size={12}>
                    <CustomButton
                      htmlType="button"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </CustomButton>
                    <CustomButton
                      htmlType="button"
                      type="primary"
                      icon={<PrinterOutlined />}
                      loading={printLoading}
                      disabled={printLoading || !assayData?.length}
                      onClick={() => handlePrint(dispenseId)}
                    >
                      Print
                    </CustomButton>
                  </Space>
                </FormItem>
              </div>
            </Spin>
          ) : (
            ''
          )}
        </CustomModal>
      ) : (
        ''
      )}
    </Layout>
  );
};
export default ListofDispenseMaterials;
